import { useMutation } from '@tanstack/react-query';

import { axiosPrivate } from 'app/utils';

interface UploadAssetResponse {
  id: string;
  url: string;
  thumbnailUrl: string;
}

interface UploadAssetParams {
  file: File;
  organisationId: string;
}

function uploadAsset({ file, organisationId }: UploadAssetParams): Promise<UploadAssetResponse> {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('organisationId', organisationId);
  return axiosPrivate
    .post<UploadAssetResponse>('/v3/pharmacist/assets', formData)
    .then((r) => r.data);
}

export function useUploadAsset() {
  return useMutation({
    mutationFn: uploadAsset,
    meta: { successMessage: 'Image uploaded successfully', errorMessage: 'Failed to upload image' },
  });
}
